// src/axios.js
import axios from "axios";
import router from "@/router";

const API_DOWN_URL = process.env.VUE_APP_API_DOWN_BASE_URL;

const axiosInstance = axios.create({
  baseURL: API_DOWN_URL,
  // timeout: 100000,
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json"
  }
});

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const user = JSON.parse(localStorage.getItem("userF"));
    if (user) {
      config.headers['Authorization'] = `Bearer ${user}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);


// Response interceptor for 401 handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear user data
      localStorage.removeItem("userF");
      
      // Redirect to login if not already there
      if (router.currentRoute.path !== "/login") {
        router.push({
          path: "/login",
          query: { redirect: router.currentRoute.fullPath }
        });
      }
      location.reload()
    }
    
    // You can add more specific error handling here
    if (error.response?.status === 403) {
      console.warn("Forbidden access");
    }
    
    return Promise.reject(error);
  }
);

export default axiosInstance;
